export const Int32MaxValue = 2147483647;
